import { filter, complement, isNil } from 'ramda';

/*
  Creates a redux action, filters out null/undefined properties
  Promise is there for the redux-pack lib
 */

export default (type, meta, payload, promise) =>
  filter(complement(isNil), {
    type,
    meta,
    payload,
    promise,
  });
